<template>
  <v-app class="secondary">
    <v-main>
      <card-login title="Acessar">
        <template v-slot:form>
          <!--  -->
          <!-- Componente obrigatorio - Campos do formulário -->
          <!-- <form-login :formData.sync="user" ref="form"></form-login> -->
          <!-- ............................................... -->
          <!--  -->
        </template>
        <template v-slot:control>
          <v-row>
            <!-- <v-col>
              <v-btn small text color="primary" to="/register">Quero me cadastrar</v-btn>
            </v-col> -->

            <v-col>
              <!--  -->
              <!-- Component obrigatorio - Botão de login  -->
              <v-btn block :loading="loading" color="primary" @click="handleLogin"><b> Entrar </b></v-btn>
              <!-- ....................................... -->
              <!--  -->
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col>
              <v-btn small text color="red" to="/recover">Esqueci a senha</v-btn>
            </v-col> -->
          </v-row>
        </template>
      </card-login>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  components: {
    CardLogin: () => import("@/_auth/components/containers/AuthCard.vue"),
    FormLogin: () => import("@/_auth/components/forms/Signin.vue")
  },
  data() {
    return {
      user: {
        cpf: null,
        password: null
      },
      loading: false,
      timeout: 1000
    };
  },
  methods: {
    handleLogin() {
      if (this.$auth0){
        this.$auth0.loginWithRedirect({
          appState: {
            targetPath: "/",
          },
          authorizationParams: {
            prompt: "login",
          },
        });
      }
    },
    clickLogin() {
      this.loading = true;

      setTimeout(() => {
        if (this.$refs.form.validateForm()) {
          this.submitLogin().then(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      }, this.timeout);
    },

    submitLogin() {
      return this.$auth
        .login({
          params: {
            cpf: this.user.cpf.replace(/[.-]/g, ''),
            password: this.user.password
          }
        })

        .then(response => {
          // Fecth usar tem automação dentro da configuração do plugin
          this.$sweetAlerts.toast1("success", "Seja bem vindo!");
        })

        .catch(error => {
          console.log("Erro na tentativa de fazer login..", error);
          this.$sweetAlerts.toast1("error", "Acesso negado!");
        });
    },
    ...mapActions({})
  }
};
</script>
